import { Settings } from '../models/settings.js'
import { EventName, EventType, RCEvent, NetworkEventData } from '../eventhub/eventmodels.js'
import { RidecellCallback } from '../models/ridecellcallback.js'
import { MemoryCache } from '../inmemorycache.js'
import { NetworkRequests } from '../networkrequestsbuilder.js'
import { EventController } from '../eventhub/eventcontroller.js'

export class SettingsController {
    /**
     * Creates an event to get settings from network.
     * @param {CallBack} callback - Callback for success or failure.
     */
    getSettings() {
        return new Promise((resolve, reject) => {
            if (MemoryCache.settings) {
                resolve(MemoryCache.settings);
                return;
            }

            const settingsData = new NetworkEventData(
                EventType.GET,
                NetworkRequests.settings
            );

            const settingsCallback = new RidecellCallback();
            settingsCallback.onSuccess = function success(result) {
                const settingsResult = new Settings(result);
                MemoryCache.settings = settingsResult
                resolve(settingsResult)
            }
            settingsCallback.onFailure = error => {
                reject(error)
            };

            this.sendEvent(new RCEvent(EventName.NETWORK, settingsData, settingsCallback));
        })
    }

    /**
     * Passes the event to event controller.
     * @param {RCEvent} event
     */
    sendEvent(event) {
        EventController.addEvent(event);
    }
}